import Page from "components/base/Page";
import { NavigationLink } from "components/base/base";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import PowerbiSales from "./PowerbiSales";

const AnalyticsSales = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="powerbi" element={<PowerbiSales />} />
        <Route path="*" element={<Navigate to="powerbi" />} />
      </Route>
    </Routes>
  );
};

const Layout = () => {
  return (
    <Page
      className="h-screen"
      leftButtons={
        <div className="space-x-6">
          <NavigationLink to="powerbi" title="Power BI" />
        </div>
      }
    >
      <Outlet />
    </Page>
  );
};

export default AnalyticsSales;
